export default "__VITE_ASSET__CPbLGOyB__"